import { sql } from "drizzle-orm";
import { pgTable, uuid, text, timestamp, jsonb, index, pgPolicy } from "drizzle-orm/pg-core";

// A record for later retention mapping, never permission to destroy a file.
// Preserve the source metadata because the live document row no longer exists.
export const documentDisposals = pgTable("crm_x_document_disposals", {
  id: uuid("id").primaryKey().defaultRandom(),
  objectKey: text("object_key").notNull(),
  sourceTable: text("source_table").notNull(),
  documentId: uuid("document_id").notNull(),
  organisationId: uuid("organisation_id").notNull(),
  deletedAt: timestamp("deleted_at", { withTimezone: true }).notNull().defaultNow(),
  deletedBy: text("deleted_by").notNull(),
  sourceRecord: jsonb("source_record").$type<Record<string, unknown>>().notNull(),
}, (table) => [
  index("idx_document_disposals_organisation").on(table.organisationId),
  index("idx_document_disposals_object_key").on(table.objectKey),
  pgPolicy("document_disposals_select", {
    for: "select", to: "crmx_app",
    using: sql`${table.organisationId} = get_current_organisation_id()
      AND (${table.sourceTable} <> 'crm_x_compliance_documents'
        OR get_current_user_role() IN ('system_admin', 'admin', 'compliance_officer'))`,
  }),
  pgPolicy("document_disposals_insert", {
    for: "insert", to: "crmx_app",
    withCheck: sql`${table.organisationId} = get_current_organisation_id()`,
  }),
]).enableRLS();
